<template>
  <v-navigation-drawer
    :value="isAddNewTemplateSidebarActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
    app
    @input="val => $emit('update:is-add-new-template-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">Criar Template</span>

        <v-spacer />

        <v-btn
          icon
          small
          @click="$emit('update:is-add-new-template-sidebar-active', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <v-text-field
            v-model="filaData.nome"
            outlined
            dense
            :rules="[validators.required]"
            label="Nome"
            placeholder="Nome"
            hide-details="auto"
            class="mb-6"
          />

          <v-textarea
            v-model="filaData.descricao"
            outlined
            dense
            auto-grow
            label="Descrição"
            placeholder="Descrição"
            hide-details="auto"
            class="mb-6"
          />

          <div class="d-flex justify-space-between flex-wrap flex-column flex-sm-row mb-2">
            <div class="mb-8 mb-sm-0">
              <v-checkbox
                v-model="filaData.envioEmMassa"
                label="Envio em massa"
              />
            </div>
          </div>

          <v-btn
            color="primary"
            class="me-3 mb-1"
            type="submit"
          >
            <v-progress-circular
              v-if="loading"
              color="secundary"
              class="mx-6"
              indeterminate
            />

            <span v-else>Criar</span>
          </v-btn>

          <v-btn
            color="secondary"
            class="mb-1"
            outlined
            type="reset"
            @click="resetFilaData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import { required, between } from '@core/utils/validation'
import TemplateEmailService from '@/services/modules/TemplateEmailService'

export default {
  model: {
    prop: 'isAddNewTemplateSidebarActive',
    event: 'update:is-add-new-template-sidebar-active',
  },

  props: {
    isAddNewTemplateSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  setup(_, { emit }) {
    const blankFilaData = {
      nome: '',
      descricao: '',
      envioEmMassa: false,
    }

    const valid = ref(false)
    const form = ref(null)

    const loading = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const filaData = ref(JSON.parse(JSON.stringify(blankFilaData)))
    const errorMsg = ref('Entre em contato com o servidor.')

    const resetFilaData = () => {
      filaData.value = JSON.parse(JSON.stringify(blankFilaData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-template-sidebar-active', false)
      }, 2000)
    }

    const onSubmit = async () => {
      loading.value = !loading.value

      if (valid.value) {
        try {
          await TemplateEmailService.criar(filaData.value)
          loading.value = !loading.value
          emit('refetch-data')
          resetFilaData()
        } catch {
          loading.value = !loading.value
        }
      } else {
        loading.value = !loading.value
        validate()
      }
    }

    return {
      resetFilaData,
      onSubmit,
      validate,
      form,
      filaData,
      valid,
      blankFilaData,
      loading,
      errorMsg,

      // validation
      validators: {
        required,
        between,
      },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
